import React from 'react';

export const functionalOrderIcon = () => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.37617 1.30664L0.59375 4.875H7.90625V0.375H3.88789C3.24805 0.375 2.66445 0.737109 2.37617 1.30664ZM9.03125 4.875H16.3438L14.5613 1.30664C14.273 0.737109 13.6895 0.375 13.0496 0.375H9.03125V4.875ZM16.3438 6H0.59375V13.875C0.59375 15.116 1.60273 16.125 2.84375 16.125H14.0938C15.3348 16.125 16.3438 15.116 16.3438 13.875V6Z"
                fill="#173300"
            />
        </svg>
    );
};
